import React from 'react'
import PropTypes from 'prop-types'

import DynamicWindow from './DynamicWindow'
import FullscreenWindow from './FullscreenWindow'

const Window = (props) => {
  return props.fullscreen ? <FullscreenWindow {...props} /> : <DynamicWindow {...props} />
}

Window.defaultProps = {
  fullscreen: false
}

Window.propTypes = {
  fullscreen: PropTypes.bool
}

export default Window
